import { useData } from "./DataContext.js";

import { Transition } from "react-transition-group";

import Badge from "react-bootstrap/Badge";

const style = { width: "100px" };

export default function ApplicationBadge (props)
{
    const gData = useData();
    const solution = gData.state.solutions[props.solutionId];

    let badge = (<></>);
    
    if (solution.applied === null)
    {
	badge = (
	    <Badge bg="secondary" text="white" className={"w-100 border-0 border-dark d-inline-flex flex-column justify-content-center px-2 py-1 fs-7 text-uppercase"}>
		<span className="fw-normal">Solution</span>
		<span className="fw-bold">en attente</span>
	    </Badge>
	);
    }
    
    else if (solution.applied)
    {
	badge = (
	    <Badge bg="success" text="white" className={"w-100 border-0 border-dark d-inline-flex flex-column justify-content-center px-2 py-1 fs-7 text-uppercase"}>
		<span className="fw-normal">Solution</span>
		<span className="fw-bold">appliquée</span>
	    </Badge>
	);
    }

    else {
	badge = (
	    <Badge bg="danger" text="white" className={"w-100 border-0 border-dark d-inline-flex flex-column justify-content-center px-2 py-1 fs-7 text-uppercase"}>
		<span className="fw-normal">Solution</span>
		<span className="fw-bold">rejetée</span>
	    </Badge>
	);
    }

    return (
	<Transition timeout={500} in={solution.applied !== null}>
	    {(state) => (<div className={"d-inline-flex pop-in-"+state} style={style}>{badge}</div>)}
	</Transition>
    );
}

